import React, { useState } from 'react';
import { PlaybackPaywallUiModuleBody } from '../../../../../API';
import { useLocales, useTheme } from '../../../../../hooks';
import UIModuleListItem, { IBaseUIModuleListItemProps } from '../../UIModuleListItem';
import Button from '../../../../shared/Button';
import { StayPrimaryPortrait } from '@mui/icons-material';
import { PlaybackPaywallPreview } from '../../ContentPreview/PlaybackPaywallPreview';
import { playbackPaywallListItemTestIds as testIds } from '../../../../shared/TestsIds';

export type PlaybackPaywallListItemProps = IBaseUIModuleListItemProps<PlaybackPaywallUiModuleBody>;

export function PlaybackPaywallListItem({ uiModule, ...props }: PlaybackPaywallListItemProps): JSX.Element {
  const { t } = useLocales();
  const [isPreviewShowing, setIsPreviewShowing] = useState(false);
  const { formControlColor } = useTheme();

  const onPreviewButtonClick = () => {
    setIsPreviewShowing(true);
  };

  return (
    <>
      <UIModuleListItem
        uiModule={uiModule}
        topLineTitle={<span data-testid={testIds.title}>{t('layouts.ui_module_playback_paywall')}</span>}
        collectionLine={[
          <Button
            key="preview"
            variant="text"
            size="small"
            startIcon={<StayPrimaryPortrait />}
            color={formControlColor}
            onClick={onPreviewButtonClick}
            data-testid={testIds.button}
          >
            {t('layouts.preview_contents')}
          </Button>
        ]}
        {...props}
      />
      <PlaybackPaywallPreview module={uiModule} isOpen={isPreviewShowing} setIsOpen={setIsPreviewShowing} />
    </>
  );
}
